/**
 * The Predictions page. One route, three states — OPEN, HISTORY and BOOK —
 * switched by the segmented control at the top (one route, not three).
 *
 * The names say what each is for: Open is what can still be bet on and what is
 * riding on it; History is everything already played for — the season standing,
 * the ledger and the record; Book is the tournament market book.
 *
 * THE BOOK IS A DIFFERENT KIND OF BETTING and sits in its own tab for that
 * reason. Open and History track money between MEMBERS through the ledger. The
 * book is the trip sweep: bets are placed under a free-text name so people on
 * the trip who are not in the app can have one, which is exactly why they can
 * never reach a member's ledger. See `services/market_book` on the server.
 *
 * It used to live on `/betting/book` beside a Head to Head tab this page
 * replaced — and, once this page took over `/betting`, with nothing anywhere
 * linking to it. That route now redirects here.
 */
import React, { useState } from 'react';

import BottomNav from '../BottomNav';
import PageHeader from '../components/PageHeader';
import { FiBarChart2, FiGrid, FiSettings } from 'react-icons/fi';
import { GiGolfTee } from 'react-icons/gi';

import './predictions.css';
import { Segmented } from './primitives';
import PredictionsHub from './PredictionsHub';
import HistoryView from './HistoryView';
import BookView from './BookView';

const TABS = [
  { value: 'open', label: 'Open' },
  { value: 'history', label: 'History' },
  { value: 'book', label: 'Book' },
];

const MENU_ITEMS = [
  { name: 'Leaderboard', route: '/leaderboard', icon: <FiBarChart2 size={24} /> },
  { name: 'Rounds', route: '/tournaments/scorecard-entry', icon: <FiGrid size={24} /> },
  { name: 'Play Golf', route: '/play', icon: <GiGolfTee size={24} /> },
  { name: 'Manage', route: '/setup', icon: <FiSettings size={24} /> },
];

const PredictionsPage = () => {
  const [tab, setTab] = useState('open');

  return (
    <div className="pr-page">
      <PageHeader title="Predictions" backTo={-1} />

      <div style={{ padding: '14px 14px 0' }}>
        <Segmented options={TABS} value={tab} onChange={setTab} />
      </div>

      {tab === 'open' ? <PredictionsHub /> : null}
      {tab === 'history' ? <HistoryView /> : null}
      {tab === 'book' ? <BookView /> : null}

      <BottomNav menuItems={MENU_ITEMS} />
    </div>
  );
};

export default PredictionsPage;
